import axios from '../../../../../api/axios';
export const initialState = {
  isLoaded: false,
  users: null,
  search: {},
  page: 1,
};
export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'LOADING':
      return { ...state, isLoaded: false };
    case 'LOADED':
      return { ...state, isLoaded: true };
    case 'CHANGE_FIELDS':
      return {
        ...state,
        search: {
          ...state.search,
          [payload.name]: payload.value,
        },
      };
    case 'CUSTOMERS':
      return { ...state, isLoaded: true, users: payload };
    case 'CHANGE_PAGE':
      return { ...state, page: payload };
    default:
      return { ...state };
  }
};
export const actions = {
  fetchingCustomers: async (page = 1, limit, query) => {
    try {
      const { data: customers } = await axios.post(
        `/api/v1/admin/users/list/customers`,
        {
          page,
          limit,
          query,
        }
      );
      return customers;
    } catch (error) {
      return new Error(error);
    }
  },
};
